import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";
import { Commodity } from "@/store/modules/commodities";

export const enum CommodityStatus {
  active = "active",
  archived = "archived",
}

const prettifiedCommodityStatus = {
  active: "Active",
  archived: "Archived",
};

export const prettifyCommodityStatus = (s: CommodityStatus) => {
  return prettifiedCommodityStatus[s];
};

export const commodityStatusReverseLookup = <
  { [key: string]: CommodityStatus }
>{
  active: CommodityStatus.active,
  archived: CommodityStatus.archived,
};

export interface FormCommodity {
  id: string;
  name: string;
  description: string;
  status: string;
  color: string;
}

export function buildFormCommodity() {
  const formCommodity = reactive<FormCommodity>({
    id: "",
    name: "",
    description: "",
    status: CommodityStatus.active,
    color: "",
  });

  const loadCommodityIntoForm = (c: Commodity, fc: FormCommodity) => {
    fc.id = c.id;
    fc.name = c.name;
    fc.description = c.description;
    fc.status = c.status;
    fc.color = c.color;
  };

  const commodityStatuses = reactive<CommodityStatus[]>([]);

  const loadCommodityStatusesIntoForm = (cStatuses: CommodityStatus[]) => {
    cStatuses.push(CommodityStatus.active, CommodityStatus.archived);
  };

  return {
    formCommodity,
    loadCommodityIntoForm,
    commodityStatuses,
    loadCommodityStatusesIntoForm,
  };
}

interface hasCommodityId {
  commodity_id: string;
}

export function buildFormCommodityAutocomplete() {
  let formCommodity = reactive<AutocompleteResult>({
    id: "",
    label: "",
  });

  let updateCommodity = (
    evt: AutocompleteResult,
    formCommodity: AutocompleteResult,
    formData: hasCommodityId,
  ) => {
    formCommodity.id = evt.id;
    formCommodity.label = evt.label;
    formData.commodity_id = evt.id;
  };

  return {
    formCommodity,
    updateCommodity,
  };
}
